export default class TecnicoElevadoresController {
    constructor($state, $q, UIService, AuthenticationService, AuthorizationService, ElvAgendamento, Funcionario) {
        this.$state = $state;
        this.$q = $q;
        this.UI = UIService;
        this.AuthenticationService = AuthenticationService;
        this.AuthorizationService = AuthorizationService;
        this.ElvAgendamento = ElvAgendamento;
        this.Funcionario = Funcionario;
        this.id = $state.params.id;
        this.tableLoading = true;
        // this.tipos = [];
        // this.filtersLoaded = [0, 0, 0, 0, 0];
        this.opt = $state.params;
        this.opt = this.opt || this.defaultOpt;
        // Total processes for currently being displayed
        this.total = 0;
        // Default opt state - populate later when we have all states
        this.defaultOpt = {
            page: 1,
            items: 20,
            order: "id",
            sort: "desc",
            filter: undefined
        };
        this.displayColumns = [
            {
                displayName: "Nº Processo",
                name: "numeroProcesso",
                visible: true,
                sortable: true
            },
            {
                displayName: "Morada",
                name: "morada",
                visible: true,
                sortable: true
            },
            {
                displayName: "CP4",
                name: "cp4",
                visible: true,
                sortable: true
            },
            {
                displayName: "CP3",
                name: "cp3",
                visible: true,
                sortable: false
            },
            {
                displayName: "Localidade",
                name: "localidade",
                visible: true,
                sortable: true
            },
            {
                displayName: "Data",
                name: "data",
                visible: true,
                sortable: true
            },
            {
                displayName: "Hora",
                name: "hora",
                visible: true,
                sortable: true
            },
            {
                displayName: "EMIE",
                name: "emieNome",
                visible: true,
                sortable: true
            }
        ];
        // type 's': select, 'o': plain text, 'd': date
        this.equalityFilters = [{
                val: 'a',
                name: 'Igual',
                type: 'o'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 'o'
            },
            {
                val: 'c',
                name: 'Começa por',
                type: 'o'
            },
            {
                val: 'd',
                name: 'Termina com',
                type: 'o'
            },
            {
                val: 'e',
                name: 'Contém',
                type: 'o'
            },
            {
                val: 'a',
                name: 'Igual (=)',
                type: 'd'
            },
            {
                val: 'b',
                name: 'Diferente de (≠)',
                type: 'd'
            },
            {
                val: 'c',
                name: 'Posterior a (>)',
                type: 'd'
            },
            {
                val: 'd',
                name: 'Anterior a (<)',
                type: 'd'
            },
            {
                val: 'e',
                name: 'Posterior ou igual (≥)',
                type: 'd'
            },
            {
                val: 'f',
                name: 'Anterior ou igual (≤)',
                type: 'd'
            },
            {
                val: 'a',
                name: 'Igual',
                type: 's'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 's'
            }
        ];
        this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');
        this.columns = [
            {
                id: "ElvProcesso.numeroProcesso",
                name: "Nº Processo",
                type: "o"
            },
            {
                id: "ElvElevador.morada",
                name: "Morada",
                type: "o"
            },
            {
                id: "ElvElevador.cp4",
                name: "CP4",
                type: "o"
            },
            {
                id: "ElvElevador.cp3",
                name: "CP3",
                type: "o"
            },
            {
                id: "ElvElevador.localidade",
                name: "NIF",
                type: "o"
            },
            {
                id: 'ElvAgendamento.data',
                name: 'Data',
                type: 'd',
                format: "YYYY-MM-DD",
                displayFormat: "DD/MM/YYYY"
            },
            {
                id: 'ElvAgendamento.hora',
                name: 'Hora',
                type: 'd',
                format: "HH:mm",
                displayFormat: "HH:mm"
            },
            {
                id: "ElvProcesso.emieNome",
                name: "EMIE",
                type: "o"
            }
        ];
        // Find relevant displayColumns from local storage
        if (localStorage.getItem("ElvAgendamentoTecnicoDisplayColumns")) {
            let cols = JSON.parse(localStorage.getItem("ElvAgendamentoTecnicoDisplayColumns"));
            if (cols && cols.length > 0) {
                cols.forEach((c) => {
                    let i = this.displayColumns.findIndex((x) => x.name === c.name);
                    if (i >= 0)
                        this.displayColumns[i].visible = c.visible;
                });
            }
        }
        this.customFilters = [];
        // Find customFilters from local storage
        if (localStorage.getItem("ElvAgendamentoTecnicoFilter")) {
            this.customFilters = JSON.parse(localStorage.getItem("ElvAgendamentoTecnicoFilter"));
        }
        // Check if something comes from the URL, replace the customFilters if so
        if (this.opt.filter) {
            this.customFilters = [];
            let filters = this.opt.filter.split(":");
            filters.forEach((filter) => {
                let a = filter.split("·");
                if (a.length === 3) {
                    try {
                        let data = {
                            column: {},
                            value: {},
                        };
                        data.column.selected = this.columns.find((f) => {
                            return f.id === a[0];
                        });
                        if (angular.isUndefined(data.column.selected)) {
                            throw Error();
                        }
                        this.customFilters.push(data);
                    }
                    catch (e) {
                        this.customFilters = [];
                        this.UI.addToast("Não foi possível carregar filtros");
                    }
                }
            });
            // If updated, save it to local storage
            localStorage.setItem("ElvAgendamentoTecnicoFilter", JSON.stringify(this.customFilters));
        }
        // Restore list to selected if exists
        this.customFilters.forEach((f) => {
            if (f.column && f.column.selected) {
                // if (f.column.selected.id === "ElvCliente.tipoId")
                //   f.column.selected.list = this.tipos;
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === "d") {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        // Number of selected items
        this.nSelected = 0;
        this.everythingSelected = false;
        // Only do stuff if it has permissions
        this.hasPerms().then(x => {
            this.findFuncionarioAgendamento().then(f => {
                this.funcionarioAgendamento = f;
                this.loadData();
                this.getAgendamentos();
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Não é possível consultar informação de colaborador");
                $state.go($state.previous.name, $state.previous.params);
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não é possível consultar calendarização");
            $state.go($state.previous.name, $state.previous.params);
        });
    }
    hasPerms = () => {
        let defer = this.$q.defer();
        if (this.AuthorizationService.canPerform('elvListarTodosAgendamentos')) {
            defer.resolve(true);
        }
        else {
            if (this.AuthenticationService.getId() == this.id) { // Relaxed == comparison is required
                defer.resolve(true);
            }
            else {
                defer.reject(false);
            }
        }
        return defer.promise;
    };
    isColumnVisible = (column) => {
        let f = this.displayColumns.find((x) => x.name === column);
        return _.isEmpty(f) ? false : f.visible;
    };
    clearFilter = () => {
        localStorage.removeItem('ElvAgendamentoTecnicoFilter');
        this.customFilters = [];
        this.getAgendamentos();
    };
    // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
    setWhereField = (data, whereObject, whereOrObject) => {
        // Check if have this entry in whereOr already
        if (whereOrObject.find((x) => x.key === data.key)) {
            // If so, add it here then
            whereOrObject.push({
                key: data.key,
                value: data.value,
            });
        }
        else {
            // Not in OR, check if there's an entry of this key in whereObject already
            if (whereObject[data.key]) {
                // Already have an entry for this key, transform it into an OR and add it and the new one
                whereOrObject.push({
                    key: data.key,
                    value: whereObject[data.key],
                });
                delete whereObject[data.key];
                whereOrObject.push({
                    key: data.key,
                    value: data.value,
                });
            }
            else {
                // It's the first entry of this key, use whereObject only
                whereObject[data.key] = data.value;
            }
        }
    };
    // Returns a whereFields object to use in table() remote methods (ativo, interacao)
    // WhereLiteral should be defined locally
    setWhereFields = (customFilters, literal, orsLiteral) => {
        let where = {};
        let whereDates = [];
        let whereNextDates = [];
        let whereLiteral = literal || {};
        let whereOrLiteral = orsLiteral || [];
        let whereOr = [];
        customFilters.forEach((f) => {
            let data = {};
            data.key = f.column.selected.id;
            // Generated dates - Assuming if no . exists in field, it's always generated date
            if (f.column.selected.id.split(".").filter(Boolean).length === 1 && f.column.selected.type === "d") {
                whereNextDates.push({
                    key: data.key,
                    comp: f.values.selected.val,
                    value: f.value,
                    format: f.column.selected.format,
                });
            }
            else {
                // All other cases where fields exist in database
                if (f.column.selected.type === "o") {
                    data.value = f.value;
                    this.setWhereField(data, where, whereOr);
                }
                else {
                    if (f.column.selected.type === "d") {
                        whereDates.push({
                            key: data.key,
                            comp: f.values.selected.val,
                            value: f.value,
                            format: f.column.selected.format,
                        });
                    }
                    else {
                        // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
                        if (f.value.selected.id)
                            data.value = f.value.selected.id;
                        else
                            data.value = f.value.selected.value;
                        this.setWhereField(data, whereLiteral, whereOrLiteral);
                    }
                }
            }
        });
        return {
            where: where,
            whereDates: whereDates,
            whereNextDates: whereNextDates,
            whereLiteral: whereLiteral,
            whereOr: whereOr,
            whereOrLiteral: whereOrLiteral,
        };
    };
    // Just load user info
    findFuncionarioAgendamento = () => this.Funcionario.findById({ id: this.id }).$promise;
    loadData = () => {
        // Nothing to load
    };
    getAgendamentos = () => {
        this.tableLoading = true;
        let whereFields = this.setWhereFields(this.customFilters, { 'ElvAgendamento.active': 1, 'ElvAgendamento.tecnicoId': this.id });
        this.ElvAgendamento.table({
            params: {
                fields: [
                    "ElvProcesso.id as id",
                    "ElvProcesso.numeroProcesso as numeroProcesso",
                    "ElvElevador.morada as morada",
                    "ElvElevador.cp4 as cp4",
                    "ElvElevador.cp3 as cp3",
                    "ElvElevador.localidade as localidade",
                    "ElvAgendamento.data as data",
                    "ElvAgendamento.hora as hora",
                    "ElvProcesso.emieNome as emieNome"
                ],
                from: ["ElvAgendamento", "ElvProcesso", "ElvElevador"],
                referencesOrigin: [undefined, undefined, "ElvElevador.id"],
                references: [undefined, "ElvAgendamento.processoId", "ElvProcesso.elevadorId"],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                limit: this.opt.items,
                skip: (this.opt.page - 1) * this.opt.items,
            },
        })
            .$promise.then((res) => {
            let page = this.opt.page;
            let items = this.opt.items;
            let total = res.count;
            this.start = total > 0 ? (page - 1) * items + 1 : 0;
            if (this.start - 1 + items >= total) {
                this.end = total;
            }
            else {
                this.end = Number.parseInt(this.start - 1 + items);
            }
            this.agendamentos = res.data;
            console.log(this.agendamentos);
            this.total = total;
            this.tableLoading = false;
        }).catch((e) => {
            console.log(e);
            this.tableLoading = false;
            this.UI.addToast("Não foi possível carregar clientes com os parâmetros fornecidos.");
        });
    };
    hasSelect = () => {
        return _.some(this.agendamentos, (a) => a.selected === true);
    };
    selectAll = () => {
        if (this.allSelected) {
            // Not all are selected, select all
            this.agendamentos.forEach((a) => {
                a.selected = true;
            });
            this.nSelected = this.agendamentos.filter((a) => a.selected).length;
        }
        else {
            // Remove all selections
            this.agendamentos.forEach((a) => {
                a.selected = false;
            });
            this.nSelected = 0;
        }
        // this.everythingSelected = false;
    };
    // NOT USED IN THIS VIEW
    selectEverything = (type) => {
        //   if (!type) {
        //     this.agendamentos.forEach((a) => {
        //       a.selected = false;
        //     });
        //     this.nSelected = 0;
        //     this.allSelected = false;
        //   }
        //   this.everythingSelected = !!type;
    };
    selectItem = () => {
        this.nSelected = _.filter(this.agendamentos, (r) => r.selected).length;
        this.allSelected = this.nSelected >= this.agendamentos.length;
        // this.everythingSelected = false;
    };
    sort = (key) => {
        if (!key.sortable) {
            return;
        }
        let keyname = key.name;
        if (this.opt.order === keyname)
            this.opt.page = 1;
        this.opt.order = keyname;
        this.opt.sort = this.opt.sort === "asc" ? "desc" : "asc";
        this.$state.go("app.elv.agendamentos.details", this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: "replace",
            // inherit the current params on the url
            inherit: true,
        });
        this.getAgendamentos();
    };
    item = (val) => {
        this.opt.items = val;
        this.$state.go("app.elv.agendamentos.details", this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: "replace",
            // inherit the current params on the url
            inherit: true,
        });
        this.getAgendamentos();
    };
    page = (sum) => {
        this.opt.page += sum;
        if (this.opt.page < 1)
            this.opt.page = 1;
        if (this.opt.page > Math.ceil(this.total / this.opt.items))
            this.opt.page = Math.ceil(this.total / this.opt.items);
        this.$state.go("app.elv.agendamentos.details", this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: "replace",
            // inherit the current params on the url
            inherit: true,
        });
        this.getAgendamentos();
    };
    openFilter = () => {
        // let result = this.filtersLoaded.reduce((a, b) => a + b, 0);
        //
        // if (result !== this.filtersLoaded.length) {
        //   this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
        //   return;
        // }
        // if (!this.tipos.length) {
        //   this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
        //   return;
        // }
        this.columns.forEach((f) => {
            // if (f.id === "ElvCliente.tipoId")
            //   f.list = this.tipos;
        });
        // Copy column to be used in
        this.editColumns = angular.copy(this.columns);
        // Restore list to selected
        this.customFilters.forEach((f) => {
            if (f.column && f.column.selected) {
                // if (f.column.selected.id === "ElvCliente.tipoId")
                //   f.column.selected.list = this.tipos;
            }
        });
        // Copy customFilter to another variable so we can edit it all we want
        this.editCustomFilters = angular.copy(this.customFilters);
        // Show side panel
        this.fs = true;
    };
    oldColumn = ($item, i) => {
        //Infinite Scroll Magic
        i.infiniteScroll = {};
        i.infiniteScroll.numToAdd = 20;
        i.infiniteScroll.currentItems = 20;
        if ($item.type === "s")
            i.value = {};
        else
            i.value = "";
        i.addMoreItems = function () {
            i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
        };
    };
    applyFilter = () => {
        // Parse values from sidebar
        this.editCustomFilters = _.filter(this.editCustomFilters, (f) => f.column && !_.isEmpty(f.value));
        // Remove list for column, no need to save it
        this.editCustomFilters.forEach((f) => {
            if (f.column && f.column.selected) {
                f.column.selected.list = [];
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === "d") {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        this.customFilters = angular.copy(this.editCustomFilters);
        localStorage.setItem("ElvAgendamentoTecnicoFilter", JSON.stringify(this.customFilters));
        this.fs = false;
        // Go to first page for results
        this.opt.page = 1;
        this.$state.go("app.elv.agendamentos.details", this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: "replace",
            // inherit the current params on the url
            inherit: true,
        });
        this.getAgendamentos();
    };
    selectVisibleColumns = () => {
        let options = {
            size: "md",
            template: require("./columns.dialog.html"),
            controller: ["$dialog", "$scope", (dialog, scope) => {
                    scope.title = "Editar Campos Visíveis";
                    scope.displayColumns = angular.copy(this.displayColumns);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss("cancel");
                    };
                },
            ],
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.displayColumns) {
                this.displayColumns = angular.copy(res.displayColumns);
                // Save it to local storage
                localStorage.setItem("ElvClienteDisplayColumns", JSON.stringify(this.displayColumns));
            }
        });
    };
}
TecnicoElevadoresController.$inject = ['$state', '$q', 'UIService', 'AuthenticationService', 'AuthorizationService', 'ElvAgendamento', 'Funcionario'];
